module.exports = __webpack_public_path__ + "img/subtitle.22c43d97.png";